<template>
  <section>
    <!--工具条-->
    <el-form
      :inline="true"
      v-if="buttonList != null && buttonList.length > 0"
      :model="filters"
      @submit.native.prevent
    >
      <el-form-item label="规则名称">
        <el-input v-model="filters.Name" placeholder="请输入规则名称"></el-input>
      </el-form-item>
      <el-form-item label="解锁类型">
        <el-select v-model="filters.UnlockType" clearable placeholder="请选择">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="看完任意1个可解锁" :value="0"></el-option>
          <el-option label="看完任意N个可解锁" :value="1"></el-option>
          <el-option label="全部看完可解锁" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="filters.Status" clearable placeholder="请选择状态">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="启用" :value="1"></el-option>
          <el-option label="禁用" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <el-button
          :type="
            item.Func &&
            (item.Func.toLowerCase().indexOf('handledel') != -1 ||
              item.Func.toLowerCase().indexOf('stop') != -1)
              ? 'danger'
              : 'primary'
          "
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      style="width: 100%"
    >
      <el-table-column prop="Name" label="规则名称" min-width="200"></el-table-column>
      <el-table-column prop="UnlockTypeStr" label="解锁类型" min-width="180"></el-table-column>
      <el-table-column label="规则详情" min-width="400" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.PreCurriculumNames || scope.row.TargetCurriculumNames"
            style="display: inline-flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: 4px;">
            <el-tag type="success" size="small" style="max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
              {{ formatCurriculumNames(scope.row.PreCurriculumNames, 1)[0] || '-' }}
            </el-tag>
            <el-tag v-if="getCurriculumCount(scope.row.PreCurriculumNames) > 1" type="info" size="mini">
              +{{ getCurriculumCount(scope.row.PreCurriculumNames) - 1 }}
            </el-tag>
            <span style="color: #409EFF; font-size: 16px; margin: 0 4px;">→</span>
            <el-tag type="warning" size="small" style="max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
              {{ formatCurriculumNames(scope.row.TargetCurriculumNames, 1)[0] || '-' }}
            </el-tag>
            <el-tag v-if="getCurriculumCount(scope.row.TargetCurriculumNames) > 1" type="info" size="mini">
              +{{ getCurriculumCount(scope.row.TargetCurriculumNames) - 1 }}
            </el-tag>
            <!-- 只有眼睛图标触发浮层 -->
            <el-popover placement="top" width="750" trigger="click">
              <div class="mindmap-container">
                <div class="mindmap-left">
                  <div class="mindmap-title mindmap-title-pre">
                    📚 前置课程 ({{ getCurriculumCount(scope.row.PreCurriculumNames) }})
                    <el-button type="text" size="mini" class="mindmap-quote-btn" @click="handleQuote(scope.row, 'pre')" title="引用到新规则">
                      <i class="el-icon-document-copy"></i> 引用
                    </el-button>
                  </div>
                  <div class="mindmap-list">
                    <div
                      v-for="(name, index) in formatCurriculumNames(scope.row.PreCurriculumNames, 999)"
                      :key="'pre-' + index"
                      class="mindmap-item mindmap-item-pre"
                    >
                      <span class="mindmap-dot" style="background: #67C23A;"></span>
                      <span>{{ name }}</span>
                    </div>
                    <div v-if="!scope.row.PreCurriculumNames" class="mindmap-empty">无</div>
                  </div>
                </div>
                <div class="mindmap-center">
                  <div class="mindmap-line mindmap-line-left"></div>
                  <div class="mindmap-rule-box">
                    <div class="mindmap-rule-name">{{ scope.row.Name }}</div>
                    <div class="mindmap-rule-type">{{ scope.row.UnlockTypeStr }}</div>
                  </div>
                  <div class="mindmap-line mindmap-line-right"></div>
                </div>
                <div class="mindmap-right">
                  <div class="mindmap-title mindmap-title-target">
                    🎯 目标课程 ({{ getCurriculumCount(scope.row.TargetCurriculumNames) }})
                    <el-button type="text" size="mini" class="mindmap-quote-btn" @click="handleQuote(scope.row, 'target')" title="引用到新规则">
                      <i class="el-icon-document-copy"></i> 引用
                    </el-button>
                  </div>
                  <div class="mindmap-list">
                    <div
                      v-for="(name, index) in formatCurriculumNames(scope.row.TargetCurriculumNames, 999)"
                      :key="'target-' + index"
                      class="mindmap-item mindmap-item-target"
                    >
                      <span class="mindmap-dot" style="background: #E6A23C;"></span>
                      <span>{{ name }}</span>
                    </div>
                    <div v-if="!scope.row.TargetCurriculumNames" class="mindmap-empty">无</div>
                  </div>
                </div>
              </div>
              <i slot="reference" class="el-icon-view" style="margin-left: 4px; color: #409EFF; cursor: pointer; font-size: 16px;" title="点击查看规则详情"></i>
            </el-popover>
          </div>
          <span v-else style="color: #999">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="Status" label="状态" width="80" :formatter="formatStatus"></el-table-column>
      <el-table-column prop="SortOrder" label="排序" width="80"></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" width="160" :formatter="formatDateTime"></el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleView(scope.row.Id)">详情</el-link>
          <span> | </span>
          <el-link type="primary" @click="handleEdit(scope.row.Id)">编辑</el-link>
          <span> | </span>
          <el-link type="primary" @click="handleQuoteRow(scope.row)">引用</el-link>
          <span> | </span>
          <el-link type="danger" @click="handleDelete(scope.row.Id)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--编辑/新增对话框-->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :before-close="handleDialogClose"
      :close-on-click-modal="false"
      width="800px"
    >
      <el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="规则名称" prop="Name">
              <div style="display: flex; align-items: center; gap: 6px;">
                <el-input
                  :disabled="isViewMode"
                  v-model="editForm.Name"
                  placeholder="请输入规则名称"
                  style="flex: 1;"
                ></el-input>
                <el-button
                  v-if="!isViewMode"
                  type="text"
                  :disabled="!editForm.PreCurriculumIds || editForm.PreCurriculumIds.length === 0"
                  @click="quotePreName"
                  title="引用前置课程第一个名字作为规则名称"
                >
                  <i class="el-icon-document-copy"></i> 引用
                </el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="解锁类型" prop="UnlockType">
              <el-select
                :disabled="isViewMode"
                v-model="editForm.UnlockType"
                placeholder="请选择解锁类型"
                style="width: 100%"
                @change="onUnlockTypeChange"
              >
                <el-option label="看完任意1个可解锁" :value="0"></el-option>
                <el-option label="看完任意N个可解锁" :value="1"></el-option>
                <el-option label="全部看完可解锁" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="editForm.UnlockType === 1">
          <el-col :span="12">
            <el-form-item label="需完成数量" prop="RequiredCount">
              <el-input-number
                :disabled="isViewMode"
                v-model="editForm.RequiredCount"
                :min="1"
                :max="99"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="状态" prop="Status">
              <el-select
                :disabled="isViewMode"
                v-model="editForm.Status"
                placeholder="请选择状态"
                style="width: 100%"
              >
                <el-option label="启用" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序" prop="SortOrder">
              <el-input-number
                :disabled="isViewMode"
                v-model="editForm.SortOrder"
                :min="0"
                :max="999"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="前置课程" prop="PreCurriculumIds">
              <el-select
                :disabled="isViewMode"
                v-model="editForm.PreCurriculumIds"
                multiple
                filterable
                reserve-keyword
                placeholder="请选择前置课程(完成这些课程后可解锁)"
                :loading="curriculumLoading"
                style="width: 100%"
              >
                <el-option
                  v-for="item in curriculumList"
                  :key="item.Key"
                  :label="item.Value"
                  :value="item.Key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="目标课程" prop="TargetCurriculumIds">
              <el-select
                :disabled="isViewMode"
                v-model="editForm.TargetCurriculumIds"
                multiple
                filterable
                reserve-keyword
                placeholder="请选择目标课程(被解锁的课程)"
                :loading="curriculumLoading"
                style="width: 100%"
              >
                <el-option
                  v-for="item in curriculumList"
                  :key="item.Key"
                  :label="item.Value"
                  :value="item.Key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <el-input
                :disabled="isViewMode"
                v-model="editForm.Remark"
                type="textarea"
                :rows="3"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">取消</el-button>
        <el-button
          v-if="!isViewMode"
          type="primary"
          @click="handleSubmit('editForm')"
          :loading="submitLoading"
        >
          确认
        </el-button>
      </div>
    </el-dialog>

    <!--引用确认对话框-->
    <el-dialog
      title="引用课程到新规则"
      :visible.sync="quoteDialogVisible"
      width="420px"
      :close-on-click-modal="false"
    >
      <div style="margin-bottom: 16px; color: #606266;">
        将 <el-tag :type="quoteSource === 'pre' ? 'success' : 'warning'" size="small">{{ quoteSourceLabel }}</el-tag>
        中的 <span style="font-weight: bold;">{{ quoteCurriculumCount }}个课程</span> 应用到新规则的：
      </div>
      <el-radio-group v-model="quoteTarget" style="display: flex; flex-direction: column; gap: 12px;">
        <el-radio label="pre">
          <span style="font-size: 14px;">📚 前置课程（完成这些课程后可解锁）</span>
        </el-radio>
        <el-radio label="target">
          <span style="font-size: 14px;">🎯 目标课程（被解锁的课程）</span>
        </el-radio>
      </el-radio-group>
      <div slot="footer">
        <el-button @click="quoteDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmQuote">确认并新增</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  GetUnlockRuleList,
  GetUnlockRule,
  AddUnlockRule,
  UpdateUnlockRule,
  DeleteUnlockRule,
  GetCurriculumSelectList,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";

export default {
  data() {
    return {
      filters: {
        Name: "",
        UnlockType: -1,
        Status: -1,
      },
      tableData: [],
      total: 0,
      page: 1,
      listLoading: false,
      buttonList: [],
      currentRow: null,

      // 对话框
      dialogVisible: false,
      dialogTitle: "",
      isViewMode: false,
      submitLoading: false,
      editForm: {
        Id: 0,
        Name: "",
        UnlockType: 0,
        RequiredCount: 1,
        Status: 1,
        SortOrder: 0,
        Remark: "",
        PreCurriculumIds: [],
        TargetCurriculumIds: [],
      },
      editFormRules: {
        Name: [{ required: true, message: "请输入规则名称", trigger: "blur" }],
        UnlockType: [{ required: true, message: "请选择解锁类型", trigger: "change" }],
        Status: [{ required: true, message: "请选择状态", trigger: "change" }],
        PreCurriculumIds: [{ required: true, message: "请选择前置课程", trigger: "change", type: "array" }],
        TargetCurriculumIds: [{ required: true, message: "请选择目标课程", trigger: "change", type: "array" }],
      },

      // 课程下拉
      curriculumList: [],
      curriculumLoading: false,

      // 引用功能
      quoteDialogVisible: false,
      quoteSource: 'pre',       // 引用来源: pre/target
      quoteTarget: 'pre',       // 应用到: pre/target
      quoteRow: null,            // 引用的行数据
    };
  },
  computed: {
    quoteSourceLabel() {
      return this.quoteSource === 'pre' ? '前置课程' : '目标课程';
    },
    quoteCurriculumCount() {
      if (!this.quoteRow) return 0;
      const names = this.quoteSource === 'pre' ? this.quoteRow.PreCurriculumNames : this.quoteRow.TargetCurriculumNames;
      return this.getCurriculumCount(names);
    },
  },
  methods: {
    // 获取列表
    getList() {
      let params = {
        ...this.filters,
        PageIndex: this.page,
        PageSize: 50,
      };
      this.listLoading = true;
      GetUnlockRuleList(params).then((res) => {
        this.listLoading = false;
        if (res.data && res.data.success) {
          this.tableData = res.data.response.data;
          this.total = res.data.response.dataCount;
        }
      });
    },
    // 搜索
    getModules_search() {
      this.page = 1;
      this.getList();
    },
    // 分页
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    // 选中行
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    // 按钮调用
    callFunc(item) {
      this[item.Func].apply(this, item);
    },
    // 新增
    handleAdd() {
      this.dialogTitle = "新增解锁规则";
      this.isViewMode = false;
      this.resetForm();
      this.editForm.SortOrder = this.getNextSortOrder();
      this.dialogVisible = true;
    },
    // 查看
    handleView(id) {
      this.dialogTitle = "查看解锁规则";
      this.isViewMode = true;
      this.loadDetail(id);
    },
    // 编辑
    handleEdit(id) {
      this.dialogTitle = "编辑解锁规则";
      this.isViewMode = false;
      this.loadDetail(id);
    },
    // 加载详情
    loadDetail(id) {
      GetUnlockRule({ id: id }).then((res) => {
        if (res.data && res.data.success) {
          const data = res.data.response;
          this.editForm = {
            Id: data.Id,
            Name: data.Name,
            UnlockType: data.UnlockType,
            RequiredCount: data.RequiredCount,
            Status: data.Status,
            SortOrder: data.SortOrder,
            Remark: data.Remark,
            PreCurriculumIds: data.PreCurriculumIds || [],
            TargetCurriculumIds: data.TargetCurriculumIds || [],
          };
          this.dialogVisible = true;
        }
      });
    },
    // 删除
    handleDelete(id) {
      this.$confirm("确认删除该解锁规则吗?", "提示", {
        type: "warning",
      }).then(() => {
        DeleteUnlockRule({ id: id }).then((res) => {
          if (res.data && res.data.success) {
            this.$message({ message: "删除成功", type: "success" });
            this.getList();
          } else {
            this.$message({ message: res.data.msg || "删除失败", type: "error" });
          }
        });
      }).catch(() => {});
    },
    // 提交表单
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          const params = { ...this.editForm };
          const request = params.Id > 0 ? UpdateUnlockRule : AddUnlockRule;
          request(params).then((res) => {
            this.submitLoading = false;
            if (res.data && res.data.success) {
              this.$message({ message: res.data.msg || "操作成功", type: "success" });
              this.dialogVisible = false;
              this.getList();
            } else {
              this.$message({ message: res.data.msg || "操作失败", type: "error" });
            }
          });
        }
      });
    },
    // 关闭对话框
    handleDialogClose() {
      this.dialogVisible = false;
      this.resetForm();
    },
    // 重置表单
    resetForm() {
      this.editForm = {
        Id: 0,
        Name: "",
        UnlockType: 0,
        RequiredCount: 1,
        Status: 1,
        SortOrder: 0,
        Remark: "",
        PreCurriculumIds: [],
        TargetCurriculumIds: [],
      };
    },
    // 解锁类型变化
    onUnlockTypeChange(val) {
      if (val !== 1) {
        this.editForm.RequiredCount = 1;
      }
    },
    // 加载全部课程列表（一次性）
    loadCurriculumList() {
      this.curriculumLoading = true;
      GetCurriculumSelectList({ name: "" }).then((res) => {
        this.curriculumLoading = false;
        if (res.data && res.data.success) {
          this.curriculumList = res.data.response;
        }
      });
    },
    // 格式化课程名称 - 返回前N个
    formatCurriculumNames(names, limit = 3) {
      if (!names) return [];
      // 支持多种分隔符：逗号、顿号、分号、换行符
      const nameArray = names.split(/[,，、;；\n]/).map(name => name.trim()).filter(name => name);
      return nameArray.slice(0, limit);
    },
    // 获取课程总数
    getCurriculumCount(names) {
      if (!names) return 0;
      // 支持多种分隔符：逗号、顿号、分号、换行符
      const count = names.split(/[,，、;；\n]/).filter(name => name.trim()).length;
      return count;
    },
    // 格式化状态
    formatStatus(row) {
      return row.Status === 1 ? "启用" : "禁用";
    },
    // 格式化日期
    formatDateTime(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      return util.formatDate.format(new Date(data), "yyyy-MM-dd hh:mm");
    },
    // 引用 - 打开确认弹框（从思维导图浮层）
    handleQuote(row, source) {
      this.quoteRow = row;
      this.quoteSource = source;
      this.quoteTarget = source; // 默认同位置
      this.quoteDialogVisible = true;
    },
    // 引用 - 从操作列触发，整行引用
    handleQuoteRow(row) {
      this.dialogTitle = "新增解锁规则";
      this.isViewMode = false;
      this.resetForm();
      // 直接用列表返回的ID
      this.editForm.PreCurriculumIds = (row.PreCurriculumIds || []).slice();
      this.editForm.TargetCurriculumIds = (row.TargetCurriculumIds || []).slice();
      // 默认规则名 = 前置课程第一个名字
      if (this.editForm.PreCurriculumIds.length > 0) {
        const first = this.curriculumList.find(c => c.Key === this.editForm.PreCurriculumIds[0]);
        if (first) this.editForm.Name = first.Value;
      }
      this.editForm.SortOrder = this.getNextSortOrder();
      this.dialogVisible = true;
    },
    // 引用 - 确认后新增（从思维导图浮层）
    confirmQuote() {
      // 直接用列表返回的ID
      const ids = this.quoteSource === 'pre'
        ? (this.quoteRow.PreCurriculumIds || []).slice()
        : (this.quoteRow.TargetCurriculumIds || []).slice();
      this.quoteDialogVisible = false;
      this.dialogTitle = "新增解锁规则";
      this.isViewMode = false;
      this.resetForm();
      if (this.quoteTarget === 'pre') {
        this.editForm.PreCurriculumIds = ids;
      } else {
        this.editForm.TargetCurriculumIds = ids;
      }
      // 默认规则名 = 弹框中前置课程第一个名字
      if (this.editForm.PreCurriculumIds.length > 0) {
        const first = this.curriculumList.find(c => c.Key === this.editForm.PreCurriculumIds[0]);
        if (first) this.editForm.Name = first.Value;
      }
      this.editForm.SortOrder = this.getNextSortOrder();
      this.dialogVisible = true;
    },
    // 获取下一个排序值
    getNextSortOrder() {
      if (!this.tableData || this.tableData.length === 0) return 1;
      const max = Math.max(...this.tableData.map(r => r.SortOrder || 0));
      return max + 1;
    },
    // 引用前置课程第一个名字作为规则名称
    quotePreName() {
      if (this.editForm.PreCurriculumIds && this.editForm.PreCurriculumIds.length > 0) {
        const firstId = this.editForm.PreCurriculumIds[0];
        const found = this.curriculumList.find(c => c.Key === firstId);
        if (found) {
          this.editForm.Name = found.Value;
        }
      }
    },
  },
  mounted() {
    this.getList();
    this.loadCurriculumList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>

<style>
/* 思维导图浮层样式（不能scoped，因为popover渲染在body下） */
.mindmap-container {
  display: flex;
  align-items: stretch;
  min-height: 120px;
  padding: 12px 8px;
  gap: 0;
}
.mindmap-left,
.mindmap-right {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.mindmap-center {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 0 4px;
  margin-top: 36px;
}
.mindmap-title {
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 2px solid #eee;
}
.mindmap-title-pre {
  color: #67C23A;
  border-color: #67C23A;
  text-align: right;
}
.mindmap-title-target {
  color: #E6A23C;
  border-color: #E6A23C;
  text-align: left;
}
.mindmap-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-height: 300px;
  overflow-y: auto;
  flex: 1;
  justify-content: center;
}
.mindmap-item {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  color: #333;
  line-height: 1.4;
  word-break: break-all;
}
.mindmap-item-pre {
  background: #f0f9eb;
  border-right: 3px solid #67C23A;
  justify-content: flex-end;
  text-align: right;
  flex-direction: row-reverse;
}
.mindmap-item-pre .mindmap-dot {
  margin-left: 8px;
  margin-right: 0;
}
.mindmap-item-target {
  background: #fdf6ec;
  border-left: 3px solid #E6A23C;
  text-align: left;
}
.mindmap-item-target .mindmap-dot {
  margin-right: 8px;
}
.mindmap-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-block;
}
.mindmap-line {
  width: 30px;
  height: 2px;
  background: #C0C4CC;
}
.mindmap-line-left {
  background: linear-gradient(to right, #67C23A, #C0C4CC);
}
.mindmap-line-right {
  background: linear-gradient(to right, #C0C4CC, #E6A23C);
}
.mindmap-rule-box {
  background: linear-gradient(135deg, #409EFF, #337ecc);
  color: #fff;
  border-radius: 8px;
  padding: 10px 14px;
  text-align: center;
  min-width: 100px;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}
.mindmap-rule-name {
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
}
.mindmap-rule-type {
  font-size: 11px;
  opacity: 0.9;
  white-space: nowrap;
}
.mindmap-empty {
  color: #999;
  font-size: 12px;
  padding: 8px;
  text-align: center;
}
.mindmap-quote-btn {
  padding: 0 4px;
  font-size: 12px;
  margin-left: 6px;
  vertical-align: middle;
}
</style>
